import React from 'react';
import { DateTime } from 'luxon';

import { CheckOut } from '../../types';
import FieldLabelAndValue from '../FieldLabelAndValue';
import CheckoutItemList from './CheckoutItemList';
import FieldValue from '../FieldValue';
import { formatAbn } from '../../lib/formatter';
import DollarAndCentsText from '../DollarAndCentsText';

interface Props {
  checkout: CheckOut;
}

const EquipmentFinanceCheckoutSummary = (props: Props) => {
  const { checkout } = props;

  return (
    <>
      <FieldLabelAndValue label='Transaction Date' value={DateTime.now().toFormat('dd MMM yyyy')} dataTestId='uia-transactionDate' />
      <FieldLabelAndValue label='Description of Goods' dataTestId='uia-descriptionOfGoods'>
        <CheckoutItemList items={checkout.itemDescriptions} />
      </FieldLabelAndValue>
      <FieldLabelAndValue label='Merchant' dataTestId='uia-merchantAccount'>
        <FieldValue dataTestId='uia-merchantAccountName'>{checkout.accountName}</FieldValue>
        <FieldValue dataTestId='uia-merchantAbn'>{`ABN: ${formatAbn(checkout.abn)}`}</FieldValue>
      </FieldLabelAndValue>
      <FieldLabelAndValue label='Financed Transact Amount' dataTestId='uia-amount'>
        <FieldValue dataTestId='uia-amount'>
          <DollarAndCentsText amount={checkout.amount} />
        </FieldValue>
      </FieldLabelAndValue>
    </>
  );
};

export default EquipmentFinanceCheckoutSummary;
